var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabicon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3273 5.83154L11.2463 12.9126L7.08094 8.74727L1.66602 14.1622",
    stroke: "#2F91F8",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3291 5.83154H18.3275V10.8299",
    stroke: "#2F91F8",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9936,
    height: 19.9936,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabicon01);
export default __webpack_public_path__ + "static/media/tabicon01.70efe613cda82bd0379711457c25df98.svg";
export { ForwardRef as ReactComponent };